var React = require('react');

function TemplateInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M63.713 1H1v14.153h62.713V1Z","stroke":"#004952","strokeWidth":"2","strokeMiterlimit":"10","key":0}),React.createElement("path",{"d":"M63.713 15.153H1v48.56h62.713v-48.56ZM22.241 15.153v48.56M22.241 38.413h41.472","stroke":"#004952","strokeWidth":"2","strokeMiterlimit":"10","key":1})]);
}

TemplateInline.defaultProps = {"width":"65","height":"65","fill":"none"};

module.exports = TemplateInline;

TemplateInline.default = TemplateInline;
